(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["snip-product-buttons"] && !Shopify.designMode) return;
  try {
    const initializeYouNickBuybars = (scope = document) => {
    scope.querySelectorAll('[data-yn-sticky-purchase]').forEach((root) => {
      if (root.dataset.ynBuybarReady === 'true') return;

      const sourceButton = root.querySelector('[data-yn-primary-add]');
      const buybar = root.querySelector('[data-yn-mobile-buybar]');
      const buybarButton = root.querySelector('[data-yn-mobile-buybar-button]');
      const buybarPrice = root.querySelector('[data-yn-mobile-buybar-price]');
      const buybarCompare = root.querySelector('[data-yn-mobile-buybar-compare]');
      const buybarDiscount = root.querySelector('[data-yn-mobile-buybar-discount]');
      const buybarLabel = root.querySelector('[data-yn-mobile-buybar-label]');
      const buybarStatus = root.querySelector('[data-yn-mobile-buybar-status]');
      const sourceVariant = root.querySelector('.js-prod-form-submit .formVariantId');
      const productSection = root.closest('[data-section-type="product__section"]');
      const priceRoot = productSection?.querySelector('#product-price');

      if (!sourceButton || !buybar || !buybarButton) return;

      root.dataset.ynBuybarReady = 'true';

      document.body.querySelectorAll(':scope > [data-yn-mobile-buybar]').forEach((staleBuybar) => {
        if (staleBuybar !== buybar) staleBuybar.remove();
      });
      document.body.appendChild(buybar);

      const sync = () => {
        buybarButton.disabled = sourceButton.disabled;
        buybarButton.setAttribute('aria-disabled', String(sourceButton.disabled));

        if (buybarLabel) {
          buybarLabel.textContent = sourceButton.textContent.trim();
        }

        if (buybarStatus) {
          buybarStatus.textContent = sourceButton.disabled
            ? sourceButton.textContent.trim()
            : buybarStatus.dataset.availableCopy;
        }

        const productPrice = priceRoot?.querySelector('.price__sale [data-sale-price], .price__regular [data-regular-price]');
        if (productPrice && buybarPrice) {
          buybarPrice.textContent = productPrice.textContent.trim();
        }

        const onSale = priceRoot?.classList.contains('price--on-sale') === true;
        const comparePrice = priceRoot?.querySelector('.price__sale [data-regular-price]');
        const saleCopy = priceRoot?.querySelector('.price__badge--sale');
        if (buybarCompare) {
          buybarCompare.hidden = !onSale;
          if (comparePrice) buybarCompare.textContent = comparePrice.textContent.trim();
        }
        if (buybarDiscount) {
          buybarDiscount.hidden = !onSale;
          if (saleCopy) {
            const match = saleCopy.textContent.match(/\d+%/);
            if (match) buybarDiscount.textContent = `−${match[0]}`;
          }
        }
      };

      sync();

      new MutationObserver(sync).observe(sourceButton, {
        attributes: true,
        childList: true
      });

      if (priceRoot) {
        new MutationObserver(sync).observe(priceRoot, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }

      buybarButton.addEventListener('click', () => {
        if (!sourceButton.disabled) sourceButton.click();
      });

      sourceVariant?.addEventListener('change', sync);

      const updateVisibility = () => {
        buybar.hidden = sourceButton.getBoundingClientRect().bottom >= 0;
      };

      new IntersectionObserver(updateVisibility, {
        threshold: 0.15,
        rootMargin: '0px 0px -8% 0px'
      }).observe(sourceButton);

      window.addEventListener('scroll', updateVisibility, { passive: true });
      updateVisibility();
    });
  };

  initializeYouNickBuybars();
  document.addEventListener('shopify:section:load', (event) => initializeYouNickBuybars(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["younick-visual-system"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__ynFoundationReady) return;
    window.__ynFoundationReady = true;

    const progress = document.querySelector('.yn-scroll-progress');

    const pathFromLink = (link) => {
      try {
        return new URL(link.href, window.location.origin).pathname.replace(/\/$/, '');
      } catch (error) {
        return '';
      }
    };

    const simplify = (list, mobile) => {
      if (!list || list.dataset.ynSimpleNavigation === 'true') return;
      const paths = [
        '/collections/all',
        '/collections/okulary-korekcyjne',
        '/collections/okulary-przeciwsloneczne',
        '/collections/venus',
        '/pages/dlaczego-younick'
      ];
      const items = Array.from(list.children);
      const map = new Map();
      items.forEach((item) => {
        const link = item.querySelector('a[href]');
        if (link) map.set(pathFromLink(link), item);
      });
      const next = paths.map((path) => map.get(path)).filter(Boolean);
      if (next.length < 3) return;
      list.replaceChildren(...next);
      list.dataset.ynSimpleNavigation = 'true';
    };

    const simplifyNavigation = () => {
      simplify(document.querySelector('#main-nav'), false);
      simplify(document.querySelector('.mobile-menu__navigation > .menu__list'), true);
    };

    const updateProgress = () => {
      if (!progress) return;
      const root = document.scrollingElement || document.documentElement;
      const max = root.scrollHeight - root.clientHeight;
      progress.style.setProperty('--yn-scroll-progress', max > 0 ? root.scrollTop / max : 0);
    };

    simplifyNavigation();
    updateProgress();
    window.setTimeout(simplifyNavigation, 250);
    document.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress, { passive: true });
    document.addEventListener('shopify:section:load', simplifyNavigation);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["younick-why-v3"] && !Shopify.designMode) return;
  try {
    (() => {
    const initWhyVideo = (root) => {
      if (root.dataset.ynWhyVideoReady === 'true') return;

      const video = root.querySelector('.yn-why__film video');
      const toggle = root.querySelector('.yn-why__film-toggle');
      const icon = toggle?.querySelector('[data-yn-why-film-icon]');

      if (!video || !toggle || !icon) return;

      root.dataset.ynWhyVideoReady = 'true';
      const controller = new AbortController();
      const { signal } = controller;
      root.ynWhyVideoController = controller;
      video.controls = false;
      toggle.hidden = false;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let pausedByCustomer = false;

      const syncToggle = () => {
        const isPaused = video.paused;
        icon.textContent = isPaused ? '▶' : 'Ⅱ';
        toggle.setAttribute('aria-label', isPaused ? toggle.dataset.labelPlay : toggle.dataset.labelPause);
      };

      const tryPlay = (customerInitiated = false) => {
        if (pausedByCustomer || (reducedMotion.matches && !customerInitiated)) return;
        const playRequest = video.play();
        if (playRequest) playRequest.catch(syncToggle);
      };

      toggle.addEventListener('click', () => {
        if (video.paused) {
          pausedByCustomer = false;
          tryPlay(true);
        } else {
          pausedByCustomer = true;
          video.pause();
        }
      }, { signal });

      video.addEventListener('play', syncToggle, { signal });
      video.addEventListener('pause', syncToggle, { signal });
      video.addEventListener('canplay', tryPlay, { once: true, signal });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
        else tryPlay();
      }, { signal });

      video.closest('.yn-why__film')?.addEventListener('pointerdown', (event) => {
        if (!toggle.contains(event.target)) tryPlay();
      }, { once: true, passive: true, signal });

      reducedMotion.addEventListener('change', (event) => {
        if (event.matches) video.pause();
        else tryPlay();
      }, { signal });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) tryPlay();
          else video.pause();
        }, { threshold: 0.15 });
        observer.observe(video);
        root.ynWhyVideoObserver = observer;
      }

      if (reducedMotion.matches) video.pause();
      else tryPlay();

      syncToggle();
    };

    const initWhyVideos = () => {
      document.querySelectorAll('[data-yn-why-v3]').forEach(initWhyVideo);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWhyVideos, { once: true });
    } else {
      initWhyVideos();
    }

    document.addEventListener('shopify:section:load', initWhyVideos);
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-yn-why-v3]').forEach((root) => {
        root.ynWhyVideoController?.abort();
        root.ynWhyVideoObserver?.disconnect();
        delete root.dataset.ynWhyVideoReady;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
